import React, { ChangeEvent, CSSProperties, KeyboardEvent, useEffect, useState } from 'react'
import InputMask from 'react-input-mask'

export interface IProps {
  inputClass?: string
  id?: string
  name?: string
  value?: string
  defaultValue?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
  rf?: string
  options?: {
    maskChar?: string
    alwasShowMask?: boolean
  }
  isValid?: boolean
  style?: CSSProperties
  onChangeComplete?: (value: string) => void
  onChange?: (value: string) => void
}

/**
 * Account number input
 *
 *
 * @param inputClass (string, optional) - Css input class
 * @param id (string, optional) - Input id
 * @param name (string, optional) - Input name
 * @param value (string, required) - Contolled input value
 * @param defaultValue (string, optional) - Default value.
 * @param disabled (boolean, optional) - Enable / disable input
 * @param required (boolean, optional) - Input mandatory flag
 * @param style (css style, optional) - Additional css style
 * @param onChange (void: string, required) - On change handler
 * @param onChangeComplete (void: string, required) - On change complete handler
 * @param rf (string, optional) - Optional tracking id fro automated tests
 * @param isValid (boolean, optional) - Indicates value validation state
 * @param options (object, optional) - react-input-mask settings
 *
 */
export default function AccountNumberInput(props: IProps) {
  const {
    id,
    name,
    inputClass,
    defaultValue,
    onChange,
    placeholder,
    rf,
    disabled,
    required,
    style,
    options,
    value,
    onChangeComplete,
    isValid
  } = props

  const defValue = defaultValue ? defaultValue : ''
  const [currentValue, setCurrentValue] = useState(defValue)

  useEffect(() => {
    if (value && currentValue !== value) {
      setCurrentValue(value)
    }
  }, [value])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value)
    if (onChange) {
      onChange(e.target.value)
    }
  }

  const handleBlur = () => {
    if (onChangeComplete) {
      onChangeComplete(currentValue)
    }
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (onChangeComplete && e.key === 'Enter') {
      onChangeComplete(currentValue)
    }
  }

  const finalClass =
    !isValid && isValid !== undefined && isValid !== null ? inputClass + ' ' + 'csas-error' : inputClass

  return (
    <InputMask
      mask='999999-9999999999/9999'
      id={id}
      name={name}
      value={currentValue}
      className={finalClass}
      placeholder={placeholder}
      disabled={disabled}
      data-testid={rf}
      required={required}
      onBlur={handleBlur}
      type='tel'
      onKeyPress={handleKeyPress}
      style={style}
      {...options}
      onChange={handleChange}
    />
  )
}
